module.exports = __webpack_public_path__ + "static/img/logo12.1674d34a.png";